import * as types from '../types/operators'
import { company } from '../../api'

const operatorsApi = company.operators

export const updateExistingOperatorAct = (operator) => ({
  type: types.UPDATE_EXISTING_OPERATOR,
  operator,
})
export const setAllOperatorsAct = (operators) => ({ type: types.SET_ALL_OPERATORS, operators })
export const addNewOperatorAct = (operator) => ({ type: types.ADD_NEW_OPERATOR, operator })
export const deleteOperatorAct = (operator) => ({ type: types.DELETE_OPERATOR, operator })

export const getOperators = (params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    operatorsApi
      .getOperators(params)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(setAllOperatorsAct(data.results))
          return resolve(data)
        }
        return reject(data)
      })
      .catch(reject)
  })
}

export const addNewOperator = (operator) => (dispatch) =>
  operatorsApi
    .addOperator(operator)
    .then(({ data }) => {
      dispatch(addNewOperatorAct({ ...operator, ...data.results }))

      return data
    })
    .catch(({ response = {}, message }) => {
      throw response.data || message
    })

export const updateOperator = (operator) => (dispatch) =>
  operatorsApi
    .updateOperator(operator)
    .then(({ data, status }) => {
      dispatch(updateExistingOperatorAct(operator))

      return data
    })
    .catch(({ response = {}, message }) => {
      throw response.data || message
    })

export const deleteOperator = (operator) => (dispatch) => {
  return new Promise((resolve, reject) => {
    operatorsApi
      .deleteOperator(operator)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(deleteOperatorAct(operator))
          return resolve(data)
        }
        return reject(data)
      })
      .catch(reject)
  })
}
